<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="订单编号">
              <el-input clearable v-model="queryParamForm.orderCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="快递单号">
              <el-input
                clearable
                v-model="queryParamForm.mailingCode"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="回收商">
              <el-input
                clearable
                v-model="queryParamForm.recyclerName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="状态">
              <el-select
                clearable
                v-model="queryParamForm.status"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <el-form-item label="下单时间">
              <el-date-picker
                clearable
                v-model="queryParamForm.orderTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <el-form-item label="收货时间">
              <el-date-picker
                clearable
                v-model="queryParamForm.receiveTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <el-form-item label="质检时间">
              <el-date-picker
                clearable
                v-model="queryParamForm.qualityTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          </el-row>
           <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item label="成交时间">
              <el-date-picker
                clearable
                v-model="queryParamForm.finishTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-button type="primary" @click="getServiceProviderListSearch"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="orderCode" label="订单编号"> </el-table-column>
        <el-table-column prop="orderType" label="下单方式">
          <template slot-scope="scope">
            <span v-if="scope.row.orderType === 0">自行邮寄</span>
            <span v-else>送货上门</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderNum" label="下单数量"> </el-table-column>
        <el-table-column prop="orderAmount" label="下单金额"> </el-table-column>
        <el-table-column prop="receiveNum" label="收货数量"> </el-table-column>
        <el-table-column prop="qualityAmount" label="质检金额">
           <template slot-scope="scope">
               {{scope.row.qualityAmount>0?scope.row.qualityAmount:''}}
          </template>
        </el-table-column>
        <el-table-column prop="recoveryNum" label="回收数量"> </el-table-column>
        <el-table-column prop="recoveryAmount" label="回收金额">
            <template slot-scope="scope">
               {{scope.row.recoveryAmount>0?scope.row.recoveryAmount:''}}
          </template>
        </el-table-column>
        <el-table-column prop="mailingType" label="邮件方式">
          <template slot-scope="scope">
            <span v-if="scope.row.mailingType === 0">自行邮寄</span>
            <span v-else>送货上门</span>
          </template>
        </el-table-column>
        <el-table-column prop="mailingCode" label="快递单号"> </el-table-column>
        <el-table-column prop="recyclerName" label="回收商"> </el-table-column>
        <el-table-column prop="updateTime" label="更新时间"> </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">待发货</span>
            <span v-else-if="scope.row.status === 1">待收货</span>
            <span v-else-if="scope.row.status === 2">待质检</span>
            <span v-else-if="scope.row.status === 3">交易中</span>
            <span v-else-if="scope.row.status === 4">已完成</span>
            <span v-else-if="scope.row.status === 5">待议价</span>
            <span v-else-if="scope.row.status === 6">已取消</span>
            <span v-else-if="scope.row.status === 7">交易关闭中</span>
            <span v-else-if="scope.row.status === 8">交易已关闭</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 1">
              <el-button
                @click="editormodel(scope.row)"
                type="text"
                size="small"
                >收货</el-button
              >
              <el-button
                @click="cancelOrder(scope.row)"
                type="text"
                size="small"
                >取消</el-button
              >
            </div>
            <el-button
              @click="detail(scope.row)"
              type="text"
              size="small"
              v-else-if="scope.row.status !==1"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog title="收货操作" :visible.sync="isDlg" width="500px">
      <div style="margin: 20px">
        <div>
          <el-form
            ref="editServiceProviderForm"
            :model="editServiceProviderForm"
            :rules="editorFormRules"
            label-width="80px"
            label-position="left"
          >
            <div style="margin-bottom:10px">即将对如下订单进行收货</div>
            <el-form-item label="订单编码">{{editServiceProviderForm.orderCode}}</el-form-item>
            <el-form-item label="快递单号">{{editServiceProviderForm.mailingCode}}</el-form-item>
            <el-form-item label="收货数量" prop="receiveNum">
              <el-row>
                 <el-col :span="10">
                    <el-input
                clearable
                v-model="editServiceProviderForm.receiveNum"
              ></el-input>
                 </el-col>
                 <el-col :span="6" style="margin-left:10px">
                   台
                 </el-col>
              </el-row>
             
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center">
          <el-button
            type="primary"
            style="margin: 30px 20px"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px" @click="closeEditormodelDlg"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
       <!-- 修改或新建对话框 -->
    <el-dialog title="订单详情" :visible.sync="queryDlg" width="1000px" :before-close="closeQueryDlg">
      <div>
         <order-item-detail ref="detail"></order-item-detail>
      </div>
        <div style="text-align: right">
          <el-button style="margin: 10px 20px" @click="closeQueryDlg"
            >取消</el-button
          >
        </div>
    </el-dialog>
  </div>
</template>


<script>
import OrderItemDetail from "../../components/orderItemDetail.vue";
export default {
  components: {OrderItemDetail},
  props: {},
  data() {
    return {
      //限制
      pickerOptions1: {
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
          console.log(obj);
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day1 = 60 * 24 * 3600 * 1000;
            let maxTime = this.pickerMinDate + day1;
            let minTime = this.pickerMinDate - day1;
            return (
              time.getTime() > maxTime ||
              time.getTime() < minTime ||
              time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      // 查询数据
      queryParamForm: {
        orderCode: null,
        mailingCode: null,
        recyclerName: null,
        status: null,
        orderTime: null,
        qualityTime: null,
        receiveTime: null,
        finishTime: null,
      },
        // 订单状态选择框
      statusOptions: [{
        id: 0,
        name: '待发货'
      },{
        id: 1,
        name: '待收货'
      },{
        id: 2,
        name: '待质检'
      },{
        id: 3,
        name: '交易中'
      },{
        id: 4,
        name: '已完成'
      },{
        id: 5,
        name: '待议价'
      },{
        id: 6,
        name: '已取消'
      },{
        id: 7,
        name: '交易关闭中'
      },{
        id: 8,
        name: '交易已关闭'
      }],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据
      userInfo: {},

      isDlg: false,
      editServiceProviderForm: {
        id: null,
        status: null,
        receiveNum: 0,
      },

      editorFormRules: {
        receiveNum: [
          { required: true, message: "请输入回收数量", trigger: "change" },
        ]
      },

      dlgType: "change",

      // 选择
      loading: false,

      orderCode: '',
      queryDlg: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    cancelOrder(row){
       let self = this;
       self.$confirm("是否取消订单").then(() => {
        self.$api.updateOrder({ id:row.id,status: 6}).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "取消订单成功",
              type: "success",
            });
            this.getServiceProviderListSearch();
          }
        });
      });
    },
    detail(row){
       let self = this;
       self.orderCode = row.orderCode
       self.queryDlg = true
       this.$nextTick(()=>{
         self.$refs.detail.init(self.orderCode)
       })
       
    },
    deleteServiceProvider(id) {
      let self = this;
      self.$confirm("是否删除").then(() => {
        self.$api.deleteServiceProvider({ id: id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getServiceProviderListSearch();
          }
        });
      });
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getServiceProviderListSearch();
    },

    // 获取表格数据
    getServiceProviderListSearch() {
      let self = this;
      self.$api
        .getConsignmentOrderList({
          page: self.currentPage,
          size: self.pageSize,
          orderTimeStart: self.queryParamForm.orderTime instanceof Array && self.queryParamForm.orderTime.length>1 ? self.queryParamForm.orderTime[0] + ' 00:00:00' : null,
          orderTimeEnd: self.queryParamForm.orderTime instanceof Array && self.queryParamForm.orderTime.length>1 ? self.queryParamForm.orderTime[1] + ' 23:59:59' : null,
          receiveTimeStart: self.queryParamForm.receiveTime instanceof Array && self.queryParamForm.receiveTime.length>1 ? self.queryParamForm.receiveTime[0] + ' 00:00:00' : null,
          receiveTimeEnd: self.queryParamForm.receiveTime instanceof Array && self.queryParamForm.receiveTime.length>1 ? self.queryParamForm.receiveTime[1] + ' 23:59:59' : null,
          qualityTimeStart: self.queryParamForm.qualityTime instanceof Array && self.queryParamForm.qualityTime.length>1 ? self.queryParamForm.qualityTime[0] + ' 00:00:00' : null,
          qualityTimeEnd: self.queryParamForm.qualityTime instanceof Array && self.queryParamForm.qualityTime.length>1 ? self.queryParamForm.qualityTime[1] + ' 23:59:59' : null,
          finishTimeStart: self.queryParamForm.finishTime instanceof Array && self.queryParamForm.finishTime.length>1 ? self.queryParamForm.finishTime[0] + ' 00:00:00' : null,
          finishTimeEnd: self.queryParamForm.finishTime instanceof Array && self.queryParamForm.finishTime.length>1 ? self.queryParamForm.finishTime[1] + ' 23:59:59' : null,
          orderCode: self.queryParamForm.orderCode || null,
          mailingCode: self.queryParamForm.mailingCode || null,
          recyclerName: self.queryParamForm.recyclerName || null,
          status: self.queryParamForm.status || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 修改
    editormodel(row) {
      let self = this;
      self.editServiceProviderForm = JSON.parse(JSON.stringify(row));
      this.isDlg = false;
      this.$nextTick((e) => {
        self.isDlg = true;
      });
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
      this.queryDlg =false
    },

        // 关闭编辑对话框
    closeQueryDlg() {
      this.isDlg = false;
      this.queryDlg =false
      this.getServiceProviderListSearch();
    },

    

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editServiceProviderForm"].validate((valid) => {
        if (valid) {
          let params = {id:this.editServiceProviderForm.id,status:2,receiveNum:this.editServiceProviderForm.receiveNum};

          self.$api.updateOrder(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getServiceProviderListSearch();
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    changeStatus(row, newStatus) {
      let self = this;
      row.status = newStatus;
      row.modelId = null;
      this.$api.updateServiceProvider(row).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          self.getServiceProviderListSearch();
        }
      });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getServiceProviderListSearch();
    self.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
};
</script>
<style lang="less" scoped>
</style>
